import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import i18nCountries from 'i18n-iso-countries';
import { USAStates } from '../constants';

// ISO of Latin American countries
const latinAmericanCountries = [
  'AR',
  'BO',
  'BR',
  'CL',
  'CO',
  'CR',
  'CU',
  'DO',
  'EC',
  'SV',
  'GT',
  'HN',
  'MX',
  'NI',
  'PA',
  'PY',
  'PE',
  'PR',
  'UY',
  'VE',
];

export const useDefaultCountriesByLang = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const countries = useMemo(() => {
    const baseLang = language?.split('-')[0] || language;

    switch (baseLang) {
      case 'uk':
        // Use alpha-2 for i18n-iso-countries
        return [i18nCountries.getName('UA', 'en') ?? ''];
      case 'pl':
        return [i18nCountries.getName('PL', 'en') ?? ''];
      case 'es':
        return latinAmericanCountries.map((countryCode) => i18nCountries.getName(countryCode, 'en') ?? '');
      case 'en':
        return USAStates;
      default:
        return [];
    }
  }, [language]);

  return countries;
};
